import { Link } from 'react-router';

import { useUsers } from '@/hooks/useUsers';

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const UserListPane = () => {
  const { users, loading, error } = useUsers();

  console.log('userlistpane users', users, loading, error);

  if (loading) {
    return <div>Loading users...</div>;
  }

  if (error) {
    return <div>Error loading users: {error}</div>;
  }

  return (
    <div>
      {users.map((user) => (
        <div
          key={user.id}
          className="flex justify-between p-4 mb-2 w-full bg-white rounded-lg shadow-md"
        >
          <div className="flex gap-2 items-center">
            <span className="text-2xl">{user.emoji}</span>
            <div>
              <Link to={`/user/${user.id}`} className="font-bold text-gray-800 text-md">{user.name || user.title || 'unknown'}</Link>
              {user.name && user.title && (
                <div className="text-sm text-gray-600">{user.title}</div>
              )}
              {user.description && (
                <div className="text-sm text-gray-600">{user.description}</div>
              )}
            </div>
          </div>
          <span className="text-sm text-gray-500">{formatDate(user.created_at)}</span>
        </div>
      ))}
    </div>
  );
};
